module.exports = __webpack_public_path__ + "dist/media/logo--da.bc06526c.svg";